import { createContext, useContext } from 'react';
import type { AuthContextValue } from './types';

/**
 * O contexto e o hook, separados do provider. O AuthProvider (./auth-context)
 * importa o SDK do Cognito; quem só lê a sessão ou a provê num teste importa
 * daqui, sem puxar o provider.
 */
export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within an AuthProvider.');
  }
  return ctx;
}
